import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=2610d356&scoped=true&"
import script from "./tracking.vue?vue&type=script&lang=js&"
export * from "./tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610d356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2610d356')) {
      api.createRecord('2610d356', component.options)
    } else {
      api.reload('2610d356', component.options)
    }
    module.hot.accept("./tracking.vue?vue&type=template&id=2610d356&scoped=true&", function () {
      api.rerender('2610d356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/tracking.vue"
export default component.exports